<rask-arbetsorder-search-filter [title]="texts.filters.arbetsmoment" (toggleVisibility)="toggleShow()"
    [visible]="isVisible" [hasValues]="isDirty()" aid="filterArbetsmoment">
    <div class="produktionsplaneringsstatus-panel col-12 ps-0 ms-0">
        <div class="col-12 ps-0">
            <div class="float-start col-3">
                <div class="dummy-component-for-header">
                    <fieldset>
                        <label>
                            {{texts.valtmaskinlag}}
                        </label>
                    </fieldset>
                </div>
                <div class="checkboxes">
                    <rask-checkbox
                        aid="filterArbetsmomentValtmaskinlagJa"
                        [text]="texts.checkboxJa"
                        (change)="setValue(searchFilter.status.produktionsstatus.maskinlag, true, $event)"
                        [ngModel]="getModelFromArray(searchFilter.status.produktionsstatus.maskinlag, true)"></rask-checkbox>
                    <rask-checkbox
                        aid="filterArbetsmomentValtmaskinlagNej"
                        [text]="texts.checkboxNej"
                        (change)="setValue(searchFilter.status.produktionsstatus.maskinlag, false, $event)"
                        [ngModel]="getModelFromArray(searchFilter.status.produktionsstatus.maskinlag, false)"></rask-checkbox>
                </div>
            </div>
            <div class="col-3 group-checkboxes">
                <div class="dummy-component-for-header">
                    <fieldset>
                        <label>
                            {{texts.schemalagd}}
                        </label>
                    </fieldset>
                </div>
                <div class="checkboxes">
                    <rask-checkbox
                        aid="filterSchemalagdJa"
                        [text]="texts.checkboxJa"
                        (change)="setValue(searchFilter.status.schemalagd, true, $event)"
                        [ngModel]="getModelFromArray(searchFilter.status.schemalagd, true)"></rask-checkbox>
                    <rask-checkbox
                        aid="filterSchemalagdNej"
                        [text]="texts.checkboxNej"
                        (change)="setValue(searchFilter.status.schemalagd, false, $event)"
                        [ngModel]="getModelFromArray(searchFilter.status.schemalagd, false)"></rask-checkbox>
                </div>
            </div>
            <div class="col-3 group-checkboxes">
                <div class="dummy-component-for-header">
                    <fieldset>
                        <label>
                            {{texts.produktsatt}}
                        </label>
                    </fieldset>
                </div>
                <div class="checkboxes">
                    <rask-checkbox
                        aid="filterArbetsmomentProduktsattJa"
                        [text]="texts.checkboxJa"
                        (change)="setValue(searchFilter.status.produktionsstatus.produkter, true, $event)"
                        [ngModel]="getModelFromArray(searchFilter.status.produktionsstatus.produkter, true)"></rask-checkbox>
                    <rask-checkbox
                        aid="filterArbetsmomentProduktsattNej"
                        [text]="texts.checkboxNej"
                        (change)="setValue(searchFilter.status.produktionsstatus.produkter, false, $event)"
                        [ngModel]="getModelFromArray(searchFilter.status.produktionsstatus.produkter, false)"></rask-checkbox>
                </div>
            </div>
            <div class="col-3 group-checkboxes">
                <div class="dummy-component-for-header">
                    <fieldset>
                        <label>
                            {{texts.destinerad}}
                        </label>
                    </fieldset>
                </div>
                <div class="checkboxes">
                    <rask-checkbox
                        aid="filterArbetsmomentDestineradJa"
                        [text]="texts.checkboxJa"
                        (change)="setValue(searchFilter.status.produktionsstatus.destinerad, true, $event)"
                        [ngModel]="getModelFromArray(searchFilter.status.produktionsstatus.destinerad, true)"></rask-checkbox>
                    <rask-checkbox
                        aid="filterArbetsmomentDestineradNej"
                        [text]="texts.checkboxNej"
                        (change)="setValue(searchFilter.status.produktionsstatus.destinerad, false, $event)"
                        [ngModel]="getModelFromArray(searchFilter.status.produktionsstatus.destinerad, false)"></rask-checkbox>
                </div>
            </div>
            <div class="col-3 group-checkboxes">
                <div class="dummy-component-for-header">
                    <fieldset>
                        <label>
                            {{texts.godkandadrivningspunkter}}
                        </label>
                    </fieldset>
                </div>
                <div class="checkboxes">
                    <rask-checkbox
                        aid="filterArbetsmomentGodkandadrivningspunkterJa"
                        [text]="texts.checkboxJa"
                        (change)="setValue(searchFilter.status.produktionsstatus.drivningspunkter, true, $event)"
                        [ngModel]="getModelFromArray(searchFilter.status.produktionsstatus.drivningspunkter, true)"></rask-checkbox>
                    <rask-checkbox
                        aid="filterArbetsmomentGodkandadrivningspunkterNej"
                        [text]="texts.checkboxNej"
                        (change)="setValue(searchFilter.status.produktionsstatus.drivningspunkter, false, $event)"
                        [ngModel]="getModelFromArray(searchFilter.status.produktionsstatus.drivningspunkter, false)"></rask-checkbox>
                </div>
            </div>
            <div class="col-3 group-checkboxes">
                <div class="dummy-component-for-header">
                    <fieldset>
                        <label>
                            {{texts.skickadTillViol}}
                        </label>
                    </fieldset>
                </div>
                <div class="checkboxes">
                    <rask-checkbox
                        aid="filterSkickadTillViolJa"
                        [text]="texts.checkboxJa"
                        (change)="setValue(searchFilter.status.skickadTillViol, true, $event)"
                        [ngModel]="getModelFromArray(searchFilter.status.skickadTillViol, true)"></rask-checkbox>
                    <rask-checkbox
                        aid="filterSkickadTillViolNej"
                        [text]="texts.checkboxNej"
                        (change)="setValue(searchFilter.status.skickadTillViol, false, $event)"
                        [ngModel]="getModelFromArray(searchFilter.status.skickadTillViol, false)"></rask-checkbox>
                </div>
            </div>
            <div class="col-3 group-checkboxes">
                <div class="dummy-component-for-header">
                    <fieldset>
                        <label>
                            {{texts.arbetsorderAvslutad}}
                        </label>
                    </fieldset>
                </div>
                <div class="checkboxes">
                    <rask-checkbox
                        aid="filterArbetsorderavslutad"
                        [text]="texts.checkboxJa"
                        (change)="searchFilter.status.arbetsorderAvslutad = $event"
                        [ngModel]="hasCheckedValue(searchFilter.status.arbetsorderAvslutad)"></rask-checkbox>
                </div>
            </div>
            <div class="col-3 group-checkboxes">
                <div class="dummy-component-for-header">
                    <fieldset>
                        <label>
                            {{texts.extraordinarhandelse}}
                        </label>
                    </fieldset>
                </div>
                <div class="checkboxes">
                    <rask-checkbox
                        aid="filterExtraordinarhandelse"
                        [text]="texts.checkboxJa"
                        (change)="searchFilter.status.extraordinarhandelse = $event"
                        [ngModel]="hasCheckedValue(searchFilter.status.extraordinarhandelse)"></rask-checkbox>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 ps-0">
        <div class="component-block col-4">
            <rask-tree-selector [label]="texts.minamaskinlag"
                class="maskinlag-control"
                [items]="minaMaskinlagItems"
                (change)="updateMinamaskinlag()"
                [required]="false"
                aid="filterArbetsmomentMinamaskinlag"></rask-tree-selector>
        </div>
        <div class="component-block col-4">
            <rask-tree-selector [label]="texts.handelssortimentandgrouplabel"
                (change)="updateSelectedHandelssortiment()"
                [items]="allHandelssortiment"
                [required]="false"
                aid="filterArbetsmomentHandelssortiment"></rask-tree-selector>
        </div>
        <div class="component-block col-4">
            <rask-selector
                label="Ansvarig för avverkning"
                aid="ansvarigAvverkningsledareSearch"
                [debounceTime]="300"
                [minCharacters]="3"
                [reverseLookup]="false"
                [(ngModel)]="searchFilter.avverkningsAnsvarig"
                [formatter]="ansvarigFormatter"
                [viewSelectedFormatter]="ansvarigSelectedFormatter"
                placeholder="Ange minst tre tecken"
                [search]="searchForAnsvarigAvverningsledareTypeAhead"
                [viewFormatter]="ansvarigViewFormatter">
            </rask-selector>
        </div>
    </div>
    <div class="col-12 ps-0">
        <div class="col-4 group-checkboxes">
            <div class="dummy-component-for-header">
                <fieldset>
                    <label>
                        Restriktioner
                    </label>
                </fieldset>
            </div>
            <div class="checkboxes">
                <rask-checkbox
                    aid="restriktionAktiv"
                    text="Ej hanterad"
                    [(ngModel)]="searchFilter.restriktionStatus.aktiv"></rask-checkbox>
                <rask-checkbox
                    aid="restriktionInaktiv"
                    text="Hanterade"
                    [(ngModel)]="searchFilter.restriktionStatus.inaktiv"></rask-checkbox>
                <rask-checkbox
                    aid="restriktionNA"
                    text="Inga restriktioner"
                    [(ngModel)]="searchFilter.restriktionStatus.na"></rask-checkbox>
            </div>
        </div>
        <rask-tree-selector label="Restriktiontyp"
            [items]="restriktionsTyper"
            (change)="updateRestriktioner()"
            [required]="false"
            aid="filterArbetsmomentRestriktion"></rask-tree-selector>
    </div>
</rask-arbetsorder-search-filter>